import Ajax, { AppResponse } from './ajax'
import Swal from 'sweetalert2'

type CustomProcess<T> = (response: AppResponse<T>) => AppResponse<T> | null
class App {
  public customProcessResponse: CustomProcess<any> | null = null

  private alert<T> (response: AppResponse<T>):void {
    Swal.fire({
      html: response.errors[0],
      icon: 'error',
      timer: 10000,
      timerProgressBar: true
    })
  }

  private processResponse<T> (response: AppResponse<T>): AppResponse<T> {
    if (response.error) {
      if (this.customProcessResponse !== null) {
        const resultResponse = this.customProcessResponse(response)

        if (resultResponse !== null) {
          this.alert(resultResponse)
        }
      } else {
        this.alert(response)
      }
    }

    return response
  }

  async post<T, B = unknown> (url: string, data?: B): Promise<AppResponse<T>> {
    console.debug(`app.post(${url})`)
    const response = await Ajax.post<T>(url, data)
    return this.processResponse(response)
  }

  async get<T, B = unknown> (url: string, config?: B): Promise<AppResponse<T>> {
    console.debug(`app.get(${url})`)
    const response = await Ajax.get<T>(url, config)
    return this.processResponse(response)
  }
}

export default new App()
